import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [],
  imports: [MatDialogModule, CoreModule],
})
export class StartFlowModule {}
